import React from 'react'
// import {ColorRing} from 'react-loader-spinner'
import './PageLoading.scss'
import {toAbsoluteUrl} from '../../_metronic/helpers'

const PageLoading = () => {
  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          zIndex: '9999',
          backgroundColor: ' rgba(255,255,255,0.70)',
        }}
      >
        <div className='loaderwrapper'>
          <img src={toAbsoluteUrl('/media/misc/spinner200.gif')} alt='img' width={100} />
        </div>
      </div>
    </>
  )
}

export default PageLoading
